// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"239":"3072c004","453":"8ffa777b","820":"0556617a","902":"3072c004"}[chunkId] + ".chunk.css";
};